import Vue from 'vue'
import Meta from 'vue-meta'
import { createRouter } from './router.js'
import NoSsr from './components/no-ssr.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_head_0f515f78 from 'nuxt_plugin_head_0f515f78' // Source: ./purchase-quote/head.js (mode: 'all')
import nuxt_plugin_plugin0_939ed064 from 'nuxt_plugin_plugin0_939ed064' // Source: ./purchase-quote/plugin-0.js (mode: 'client')
import nuxt_plugin_plugin1_939de7a6 from 'nuxt_plugin_plugin1_939de7a6' // Source: ./purchase-quote/plugin-1.js (mode: 'all')
import nuxt_plugin_plugin2_939cfee8 from 'nuxt_plugin_plugin2_939cfee8' // Source: ./purchase-quote/plugin-2.js (mode: 'all')
import nuxt_plugin_plugin3_939c162a from 'nuxt_plugin_plugin3_939c162a' // Source: ./purchase-quote/plugin-3.js (mode: 'all')
import nuxt_plugin_plugin4_939b2d6c from 'nuxt_plugin_plugin4_939b2d6c' // Source: ./purchase-quote/plugin-4.js (mode: 'server')
import nuxt_plugin_plugin5_939a44ae from 'nuxt_plugin_plugin5_939a44ae' // Source: ./purchase-quote/plugin-5.js (mode: 'client')
import nuxt_plugin_plugin6_93995bf0 from 'nuxt_plugin_plugin6_93995bf0' // Source: ./purchase-quote/plugin-6.js (mode: 'all')
import nuxt_plugin_plugin7_93987332 from 'nuxt_plugin_plugin7_93987332' // Source: ./purchase-quote/plugin-7.js (mode: 'all')
import nuxt_plugin_plugin8_93978a74 from 'nuxt_plugin_plugin8_93978a74' // Source: ./purchase-quote/plugin-8.js (mode: 'all')
import nuxt_plugin_plugin9_9396a1b6 from 'nuxt_plugin_plugin9_9396a1b6' // Source: ./purchase-quote/plugin-9.js (mode: 'all')
import nuxt_plugin_plugin10_0ff08051 from 'nuxt_plugin_plugin10_0ff08051' // Source: ./purchase-quote/plugin-10.js (mode: 'all')
import nuxt_plugin_plugin11_0ff0f4b0 from 'nuxt_plugin_plugin11_0ff0f4b0' // Source: ./purchase-quote/plugin-11.js (mode: 'all')
import nuxt_plugin_plugin12_0ff1690f from 'nuxt_plugin_plugin12_0ff1690f' // Source: ./purchase-quote/plugin-12.js (mode: 'all')
import nuxt_plugin_plugin13_0ff1dd6e from 'nuxt_plugin_plugin13_0ff1dd6e' // Source: ./purchase-quote/plugin-13.js (mode: 'all')
import nuxt_plugin_plugin14_0ff251cd from 'nuxt_plugin_plugin14_0ff251cd' // Source: ./purchase-quote/plugin-14.js (mode: 'all')
import nuxt_plugin_plugin15_0ff2c62c from 'nuxt_plugin_plugin15_0ff2c62c' // Source: ./purchase-quote/plugin-15.js (mode: 'all')
import nuxt_plugin_plugin16_0ff33a8b from 'nuxt_plugin_plugin16_0ff33a8b' // Source: ./purchase-quote/plugin-16.js (mode: 'all')
import nuxt_plugin_plugin17_0ff3aeea from 'nuxt_plugin_plugin17_0ff3aeea' // Source: ./purchase-quote/plugin-17.js (mode: 'all')
import nuxt_plugin_plugin18_0ff42349 from 'nuxt_plugin_plugin18_0ff42349' // Source: ./purchase-quote/plugin-18.js (mode: 'all')
import nuxt_plugin_plugin19_0ff497a8 from 'nuxt_plugin_plugin19_0ff497a8' // Source: ./purchase-quote/plugin-19.js (mode: 'all')
import nuxt_plugin_plugin20_0ffe97d2 from 'nuxt_plugin_plugin20_0ffe97d2' // Source: ./purchase-quote/plugin-20.js (mode: 'all')
import nuxt_plugin_plugin21_0fff0c31 from 'nuxt_plugin_plugin21_0fff0c31' // Source: ./purchase-quote/plugin-21.js (mode: 'all')
import nuxt_plugin_plugin22_0fff8090 from 'nuxt_plugin_plugin22_0fff8090' // Source: ./purchase-quote/plugin-22.js (mode: 'all')
import nuxt_plugin_plugin23_0ffff4ef from 'nuxt_plugin_plugin23_0ffff4ef' // Source: ./purchase-quote/plugin-23.js (mode: 'all')
import nuxt_plugin_plugin24_1000694e from 'nuxt_plugin_plugin24_1000694e' // Source: ./purchase-quote/plugin-24.js (mode: 'all')

// Component: <NoSsr>
Vue.component(NoSsr.name, NoSsr)

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>`
Vue.component(Nuxt.name, Nuxt)

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    router,
    store,
    nuxt: {
      defaultTransition,
      transitions: [ defaultTransition ],
      setTransitions(transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [ transitions ]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },
      err: null,
      dateErr: null,
      error(err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        const nuxt = this.nuxt || this.$options.nuxt
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) ssrContext.nuxt.error = err
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    store,
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) throw new Error('inject(key, value) has no key provided')
    if (typeof value === 'undefined') throw new Error('inject(key, value) has no value provided')
    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) return
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Vue.prototype.hasOwnProperty(key)) {
        Object.defineProperty(Vue.prototype, key, {
          get() {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_head_0f515f78 === 'function') {
    await nuxt_plugin_head_0f515f78(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin0_939ed064 === 'function') {
    await nuxt_plugin_plugin0_939ed064(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin1_939de7a6 === 'function') {
    await nuxt_plugin_plugin1_939de7a6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin2_939cfee8 === 'function') {
    await nuxt_plugin_plugin2_939cfee8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin3_939c162a === 'function') {
    await nuxt_plugin_plugin3_939c162a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_plugin4_939b2d6c === 'function') {
    await nuxt_plugin_plugin4_939b2d6c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin5_939a44ae === 'function') {
    await nuxt_plugin_plugin5_939a44ae(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin6_93995bf0 === 'function') {
    await nuxt_plugin_plugin6_93995bf0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin7_93987332 === 'function') {
    await nuxt_plugin_plugin7_93987332(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin8_93978a74 === 'function') {
    await nuxt_plugin_plugin8_93978a74(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin9_9396a1b6 === 'function') {
    await nuxt_plugin_plugin9_9396a1b6(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin10_0ff08051 === 'function') {
    await nuxt_plugin_plugin10_0ff08051(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin11_0ff0f4b0 === 'function') {
    await nuxt_plugin_plugin11_0ff0f4b0(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin12_0ff1690f === 'function') {
    await nuxt_plugin_plugin12_0ff1690f(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin13_0ff1dd6e === 'function') {
    await nuxt_plugin_plugin13_0ff1dd6e(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin14_0ff251cd === 'function') {
    await nuxt_plugin_plugin14_0ff251cd(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin15_0ff2c62c === 'function') {
    await nuxt_plugin_plugin15_0ff2c62c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin16_0ff33a8b === 'function') {
    await nuxt_plugin_plugin16_0ff33a8b(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin17_0ff3aeea === 'function') {
    await nuxt_plugin_plugin17_0ff3aeea(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin18_0ff42349 === 'function') {
    await nuxt_plugin_plugin18_0ff42349(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin19_0ff497a8 === 'function') {
    await nuxt_plugin_plugin19_0ff497a8(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin20_0ffe97d2 === 'function') {
    await nuxt_plugin_plugin20_0ffe97d2(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin21_0fff0c31 === 'function') {
    await nuxt_plugin_plugin21_0fff0c31(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin22_0fff8090 === 'function') {
    await nuxt_plugin_plugin22_0fff8090(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin23_0ffff4ef === 'function') {
    await nuxt_plugin_plugin23_0ffff4ef(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin24_1000694e === 'function') {
    await nuxt_plugin_plugin24_1000694e(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    app,
    store,
    router
  }
}

export { createApp, NuxtError }
